import StoreModel from 'models/Index';

export default function getTheme(store: StoreModel) {
    return store.deviceProfile?.theme;
}
